import { oneTimeTokenClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'
import { apiOrigin, isNative } from './platform'
import { tokenStore } from './token-store'

/**
 * better-auth client. Web: same-origin cookie session. Native: Bearer token from the Keychain /
 * Keystore; the server returns a fresh token in the `set-auth-token` header.
 */
export const authClient = createAuthClient({
  baseURL: isNative ? `${apiOrigin}/api/auth` : `${window.location.origin}/api/auth`,
  plugins: [oneTimeTokenClient()],
  // On native the redirect plugin would navigate the WebView to Google, which Google blocks.
  disableDefaultFetchPlugins: isNative,
  fetchOptions: isNative
    ? {
        credentials: 'omit',
        auth: { type: 'Bearer', token: async () => (await tokenStore.get()) ?? '' },
        onSuccess: async (ctx) => {
          const token = ctx.response.headers.get('set-auth-token')
          if (token) await tokenStore.set(token)
        },
      }
    : undefined,
})
